export const defaultUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://public-api.karhoo.com'
    : 'https://public-api.sandbox.karhoo.com'

export const apiV1 = 'v1'
export const apiV2 = 'v2'
